import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Flex } from 'rebass';

import Button from './Button';
import { observer } from 'mobx-react';

export default observer(props => {
  const { nextPage, store, clickHandler, noBack } = props;

  return (
    <FormGroup>
      <Flex
        p={0}
        flexDirection="row"
        justifyContent={noBack ? 'flex-end' : 'space-between'}
      >
        {noBack ? null : (
          <Button
            muted
            onClick={() => nextPage(store.previousStepName, true)}
            type="button"
            style={{ minWidth: '128px' }}
            id="add-listing-back"
          >
            Back
          </Button>
        )}
        <Button
          onClick={() => {
            clickHandler && clickHandler();
            setTimeout(() => nextPage(store.nextStepName), 1);
          }}
          id="add-listing-next"
          action
          primary
          disabled={!store.canNext}
        >
          {store.nextStepText}
        </Button>
      </Flex>
    </FormGroup>
  );
});



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/FormNav.js